import { z } from 'zod';
export function createListResponseSchema(itemSchema) {
    return z
        .object({
        items: z.array(itemSchema),
    })
        .strict();
}
//# sourceMappingURL=ListResponse.js.map